const SectionHeader = ({ title, subtitle, count, action, className = "" }) => {
  return (
    <div
      className={`flex flex-wrap items-end justify-between gap-3 ${className}`}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-navy-700 dark:text-white">
            {title}
          </h2>
          {count !== undefined && count !== null ? (
            <span className="inline-flex items-center rounded-md bg-info-50 px-2 py-0.5 text-xs font-semibold text-info-700">
              {count}
            </span>
          ) : null}
        </div>
        {subtitle ? (
          <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
};

export default SectionHeader;
